import {
  BannerPosition,
  BannerType,
  DspAdTypeLabels,
  AdType
} from '@/api/types'

export type BannerPositionLabel = {
  id: BannerPosition
  label: string
}

export const BannerPositionLabels: Array<BannerPositionLabel> = [
  {
    id: BannerPosition.Header,
    label: 'Header'
  },
  {
    id: BannerPosition.InVideo,
    label: 'In video'
  },
  {
    id: BannerPosition.NearVideo,
    label: 'Near video'
  },
  {
    id: BannerPosition.AfterVideo,
    label: 'After video'
  },
  {
    id: BannerPosition.Within,
    label: 'Within'
  },
  {
    id: BannerPosition.Footer,
    label: 'Footer'
  }
]

export type BannerTypeLabel = {
  id: BannerType
  label: string
}

export const BannerTypeLabels: Array<BannerTypeLabel> = [
  {
    id: BannerType.Regular,
    label: 'Regular'
  },
  {
    id: BannerType.Native,
    label: 'Native'
  }
]

export const FlatDealAdTypeLabels = [
  ...DspAdTypeLabels,
  {
    type_id: AdType.Tab,
    label: 'Tab (Link URL)'
  }
]
